// The HF space mirror is pure static — the API lives on Pages. Same-origin
// callers (moxhi.pages.dev, vite/wrangler dev) use relative /api/* so local
// testing never hits production; only the HF mirror goes absolute.
export function apiBase(hostname = globalThis.location?.hostname ?? '') {
  return /\.hf\.space$/.test(hostname) ? 'https://moxhi.pages.dev' : '';
}
